module.exports = __webpack_public_path__ + "static/media/gear.ffbd19a1.svg";